import IconButton from "components/IconButton"
import { formatNumber } from "services/Utils"

export default function Item(props) {
  const { id, codigo, descricao, unidade, precoUnitarioFmt, quantidadeContratadaFmt, valorTotalFmt, filhos, itens, onClick, edit, ativo, exibirInativos } = props

  const isActive = ativo !== false
  const tipo = (!!itens || !!filhos) ? 'grupo' : 'item'

  if (tipo === 'grupo') {
    if (!isActive && !exibirInativos) return null
    return (
      <>
        <tr className={`grupo${!isActive ? ' text-muted' : ''}`} key={id}>
          <td>{codigo}</td>
          <td colSpan={5} className="text-wrap">
            {descricao}
            {!isActive && <span className="badge badge-danger ml-2">Excluído</span>}
          </td>
          <td className="d-flex flex-row gap-5px">
            <IconButton alt="LOG" iconClass="bi-clock-history" onClick={() => onClick && onClick('log', props)} />
            {edit && isActive && (
              <>
                <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => onClick && onClick('edit_group', props)} />
                <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => onClick && onClick('delete_group', props)} />
                <IconButton alt="Incluir" iconClass="bi-plus-square" onClick={() => onClick && onClick('create', props)} />
              </>
            )}
            {edit && !isActive && (
              <IconButton alt="Restaurar" iconClass="bi-arrow-counterclockwise" onClick={() => onClick && onClick('restore_group', props)} />
            )}
          </td>
        </tr>
        {itens.map(el => <Item key={el.id} {...el} onClick={onClick} edit={edit} exibirInativos={exibirInativos} />)}
        {filhos.map(el => <Item key={el.id} {...el} onClick={onClick} edit={edit} exibirInativos={exibirInativos} />)}
      </>
    )
  } else if (tipo == 'item') {
    if (!isActive && !exibirInativos) return null
    return (
      <tr key={id} className={!isActive ? 'text-muted' : ''}>
        <td>{codigo}</td>
        <td className="text-wrap">
          {descricao}
          {!isActive && <span className="badge badge-danger ml-2">Excluído</span>}
        </td>
        <td>{unidade}</td>
        <td className="text-right">R$ {precoUnitarioFmt}</td>
        <td className="text-right">{quantidadeContratadaFmt}</td>
        <td className="text-right">R$ {valorTotalFmt}</td>
        <td className="d-flex flex-row gap-5px">
          <IconButton alt="LOG" iconClass="bi-clock-history" onClick={() => onClick && onClick('log', props)} />
          {edit && isActive && (
            <>
              <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => onClick && onClick('edit', props)} />
              <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => onClick && onClick('delete', props)} />
            </>
          )}
          {edit && !isActive && (
            <IconButton alt="Restaurar" iconClass="bi-arrow-counterclockwise" onClick={() => onClick && onClick('restore_item', props)} />
          )}
        </td>
      </tr>
    )
  }
}